var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M11.95 24c-.809 0-3.08-1.818-3.298-1.99-4.614-3.674-7.527-9.282-7.65-14.831C.989 6.582.996 3.54 2.444 2.58 3.88 1.628 7.357 0 11.785 0s8.439 1.699 9.669 2.549c.154.11 1.513 1.147 1.545 4.617.052 5.11-2.981 11.186-7.373 14.765C13.933 23.306 12.756 24 11.95 24M3.152 3.664c-.638.421-.889 2.295-.863 3.489.122 5.408 2.946 10.725 7.546 14.311.132.103 1.527 1.21 2.113 1.24.232 0 1.134-.377 2.866-1.784 4.037-3.294 6.942-9.079 6.896-13.748-.025-2.769-.991-3.56-1.004-3.566-1.12-.772-4.608-2.33-8.928-2.316S4.415 2.82 3.153 3.664M7.519 16.58c.779.947 2.985 3.625 4.45 3.625 1.464 0 7.95-6.135 7.894-12.288-.016-1.829-.547-2.652-.811-2.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.068C16.351 3.641 15.093 3 12.12 3S6.281 4.262 5.362 4.877s-.861 3.062-.861 3.062c.05 2.31.81 4.802 2.214 7.061z"
  }))));
};
export default SvgTeam;